<template>
    <b-modal :id="modalId"
             :title="modalTitle"
             size="lg"
             hide-footer
             body-class="p-0"
             :no-close-on-backdrop="busy"
             :no-close-on-esc="busy"
             :hide-header-close="busy"
             @show="shown = true"
             @hide="onHide"
             @hidden="onHidden"
    >
        <div class="qna-modal-body">
            <AIQnaChatPanel :active="shown"
                            :ai-audit-id="aiAuditId"
                            :ev-id="evId"
                            :ai-ev-item="aiEvItem"
                            @busy-change="busy = $event"
                            @revision-applied="$emit('revision-applied', $event)"
            />
        </div>
    </b-modal>
</template>

<script>
import AIQnaChatPanel from './AIQnaChatPanel.vue';

export default {
    name: 'AIQnaChatModal',
    components: {AIQnaChatPanel},
    props: {
        modalId: {
            type: String,
            default: 'ai-qna-chat-modal',
        },
        aiAuditId: {
            type: [Number, String],
            default: null,
        },
        evId: {
            type: [Number, String],
            default: null,
        },
        evName: {
            type: String,
            default: '',
        },
        // valid_map 원소 (판정 요약 표시용) — {is_satisfied, reason, converted_reason, ...}
        aiEvItem: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            shown: false,
            busy: false,
        };
    },
    computed: {
        modalTitle() {
            const base = this.$t('AI 평가 Q&A');
            return this.evName ? `${base} — ${this.evName}` : base;
        },
    },
    methods: {
        onHide(event) {
            if (this.busy) event.preventDefault();
        },
        onHidden() {
            this.shown = false;
            this.busy = false;
        },
    },
};
</script>

<style scoped lang="scss">
.qna-modal-body {
    height: calc(100vh - 240px);
    min-height: 480px;
}
</style>
